import { useEffect } from 'react';
import { cookieBannerAcceptedAtom, matomoOptInAtom } from '@/global-store';
import { useAtom } from 'jotai';

/**
 * Enables Matomo analytics tracking by dynamically injecting the Matomo script
 * and initializing the global _mtm array.
 * @see https://matomo.org/matomo-on-premise/ for more details.
 */
const enableMatomoTracking = (): void => {
  if (typeof window === 'undefined') return;
  if (window.__isMatomoEnabled) return;

  window.__isMatomoEnabled = true;

  const _mtm = (window._mtm = window._mtm || []);
  _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

  const doc = window.document;

  const script = doc.createElement('script');
  script.async = true;
  script.src = 'https://mt.eye-able.com/js/container_TNeVH6iA.js';

  const firstScript = doc.getElementsByTagName('script')[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    doc.head.appendChild(script);
  }
};

/**
 * Custom hook for managing Matomo analytics opt-in state and enabling tracking.
 */
const useMatomo = () => {
  const [matomoOptIn, setMatomoOptIn] = useAtom(matomoOptInAtom);
  const [cookieBannerAccepted] = useAtom(cookieBannerAcceptedAtom);

  useEffect(() => {
    if (!cookieBannerAccepted || !matomoOptIn) return;

    enableMatomoTracking();
  }, [cookieBannerAccepted, matomoOptIn]);

  return { matomoOptIn, setMatomoOptIn, enableMatomoTracking };
};

export default useMatomo;
